export default __webpack_public_path__ + "static/media/psd_color.0d1dab40.svg";